import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const ClientAuthContext = createContext(null);

export function ClientAuthProvider({ children }) {
  const [client, setClient] = useState(null); // null = checking, false = guest, object = signed in
  const [authOpen, setAuthOpen] = useState(false);

  const refresh = useCallback(
    () => api.get("/client-auth/me").then((r) => setClient(r.data)).catch(() => setClient(false)),
    []
  );

  useEffect(() => {
    // If returning from Google OAuth, AuthCallback will establish the session first.
    if (window.location.hash?.includes("session_id=")) { setClient(false); return; }
    refresh();
  }, [refresh]);

  const logout = async () => {
    await api.post("/client-auth/logout");
    setClient(false);
  };

  return (
    <ClientAuthContext.Provider value={{ client, setClient, refresh, logout, authOpen, setAuthOpen }}>
      {children}
    </ClientAuthContext.Provider>
  );
}

export const useClientAuth = () => useContext(ClientAuthContext);
